import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import { LightsArrangement } from '../types/LightsArrangement';
import { Entity } from '@inter-ikea-core/core';

const applyNumberOfLights = (
  selectedEntity: Entity,
  productId: string,
  coreApi: CoreApi,
  currentArrangement: LightsArrangement
) => {
  const frame = coreApi.entities.getParent(selectedEntity);

  if (frame) {
    switch (currentArrangement) {
      case LightsArrangement.Single:
        coreApi.history.historyAction(() =>
          coreApi.products.addOuterLightsOnFrame(productId, frame, true, true)
        );
        break;
      case LightsArrangement.Double:
        coreApi.history.historyAction(() =>
          coreApi.products.addOuterLightsOnFrame(productId, frame, false, true)
        );
        break;
    }
    const newLights = coreApi.entities.getChildrenWithProductType(
      frame,
      ProductType.PAX_OUTER_LIGHT
    );
    coreApi.entities.select(newLights[0]);
  }
};

export default applyNumberOfLights;
